import { ApiModel } from '@composable-api/api.model'
import type { ConfigurableVariableType } from '@sim-api-enums/setting'

interface Attributes {
    [ConfigurableVariableModel.ATTR_ID]: number
    [ConfigurableVariableModel.ATTR_NAME]: string
    [ConfigurableVariableModel.ATTR_VALUE]: any // TODO: ConfigurableVariableType = STRING: 0, INT: 1, ARRAY: 2, MONETARY: 3, SENSITIVE: 4
    [ConfigurableVariableModel.ATTR_TYPE]: ConfigurableVariableType
}

export class ConfigurableVariableModel extends ApiModel<Attributes> {
    static key = 'ConfigurableVariableModel'

    static readonly ATTR_ID = 'id'
    static readonly ATTR_NAME = 'name'
    static readonly ATTR_VALUE = 'value'
    static readonly ATTR_TYPE = 'type'

    get id() {
        return this._getAttribute(ConfigurableVariableModel.ATTR_ID)
    }
    get name() {
        return this._getAttribute(ConfigurableVariableModel.ATTR_NAME)
    }
    get value() {
        return this._getAttribute(ConfigurableVariableModel.ATTR_VALUE)
    }
    get type() {
        return this._getAttribute(ConfigurableVariableModel.ATTR_TYPE)
    }
}
